import PdfPreview, { DocumentActions, usePdfBlobUrl } from "../../Components/modern/PdfPreview";
import { Container, SectionHeading } from "../../Components/modern/UI";
import { catalogs } from "../../Data/mediaData";

export default function ProductCatalog() {
  const catalog = catalogs[0];
  const { previewUrl } = usePdfBlobUrl(catalog.file);

  return (
    <section aria-labelledby="sn-catalog" className="sn-py-12 md:sn-py-16">
      <Container>
        <div className="sn-mb-8 sn-max-w-3xl">
          <SectionHeading eyebrow="Catalog" id="sn-catalog">Product Catalog</SectionHeading>
        </div>

        <article className="sn-overflow-hidden sn-rounded-card sn-border sn-border-line sn-bg-white sn-shadow-soft">
          <div className="sn-grid sn-gap-0 lg:sn-grid-cols-[360px_1fr]">
            <aside className="sn-bg-sage sn-p-5 md:sn-p-8">
              <img src={catalog.cover} alt={`${catalog.title} cover`} className="sn-mx-auto sn-w-full sn-max-w-[280px] sn-rounded sn-shadow-soft" />
              <DocumentActions file={catalog.file} fileName={catalog.fileName} previewUrl={previewUrl} className="sn-mt-6 sm:sn-flex-col" />
            </aside>

            <div className="sn-min-w-0 sn-p-4 md:sn-p-6">
              <PdfPreview file={catalog.file} title={catalog.title} />
            </div>
          </div>
        </article>
      </Container>
    </section>
  );
}
